import { lazy } from 'react'

const HomeConfig =  {
  path: '/home',
  component: lazy(() => import('./Home')),
  layout: 'BlankLayout',
}
export default HomeConfig